export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Giá Thu Mua Cạnh Tranh Nhất',
      description: 'Cam kết giá cao nhất thị trường'
    },
    {
      icon: 'ri-truck-line',
      title: 'Thu Mua Tận Nơi 24/7',
      description: 'Phục vụ mọi lúc, mọi nơi'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Thanh Toán Ngay Không Chờ Đợi',
      description: 'Thanh toán nhanh chóng, minh bạch'
    },
    {
      icon: 'ri-team-line',
      title: 'Đội Ngũ Chuyên Nghiệp',
      description: 'Nhân viên được đào tạo bài bản'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Uy Tín 15+ Năm',
      description: 'Kinh nghiệm lâu năm trong ngành'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Miễn Phí Khảo Sát',
      description: 'Đánh giá và báo giá không mất phí'
    }
  ];

  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ebfca3a21986c7ad0e381edfef8a9e9c.jpg"
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-teal-900/90 via-teal-800/85 to-blue-900/90"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 uppercase">
            TẠI SAO CHỌN<br />
            NAM PHÁT?
          </h2>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {reasons.map((reason, index) => (
            <div key={index} className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="w-14 h-14 bg-amber-400 rounded-full flex items-center justify-center shadow-lg">
                  <div className="w-14 h-14 flex items-center justify-center">
                    <i className={`${reason.icon} text-gray-900 text-2xl`}></i>
                  </div>
                </div>
              </div>
              <div>
                <h3 className="text-white text-lg font-bold mb-2">{reason.title}</h3>
                <p className="text-gray-300 text-sm">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <a href="#contact" className="inline-flex items-center gap-4 bg-amber-400 hover:bg-amber-500 text-gray-900 px-10 py-5 rounded-full text-base font-bold transition-all whitespace-nowrap shadow-2xl hover:shadow-3xl hover:scale-105 relative">
            <div className="absolute -left-3 w-14 h-14 bg-amber-500 rounded-full flex items-center justify-center shadow-lg">
              <div className="w-14 h-14 flex items-center justify-center">
                <i className="ri-shopping-bag-3-line text-white text-2xl"></i>
              </div>
            </div>
            <span className="ml-12">LIÊN HỆ NGAY ĐỂ ĐƯỢC BÁO GIÁ</span>
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-2xl"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}